import { useEffect } from 'react';
import { useAuth } from '../../providers/AuthProvider';

export default function LogoutView() {
  const { logOut } = useAuth();

  useEffect(() => logOut());

  return null;
}
